/* ============================================================
   VERA SANTORI - Favoritos
   ------------------------------------------------------------
   Guarda en el navegador los productos que marca la clienta.
   Solo se guarda el handle (el trocito final de la direccion:
   de /products/bruma se guarda 'bruma'). Con eso basta: la
   pagina de Favoritos le pide a Shopify los datos frescos de
   cada producto, asi que precios y fotos nunca se quedan viejos.

   Los favoritos viven en el navegador de cada clienta, no en su
   cuenta. Se conservan sin iniciar sesion, pero no viajan del
   movil al ordenador. Para eso haria falta una app de listas de
   deseos.

   REGLA DE ORO: como no hay copia en el servidor, esta lista solo
   se recorta cuando Shopify confirma que un producto ya no existe
   (404). Un fallo de red NUNCA borra un favorito.
   ============================================================ */
(function () {
  'use strict';

  var KEY = 'vs_favs_v2';

  /* Prefijo de idioma o mercado (/es-es/, /fr/...). Sin el, las
     peticiones fallarian en esos mercados. */
  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  var ICON = "<svg viewBox='0 0 24 24' aria-hidden='true' focusable='false'><path d='M7 4h10a1 1 0 0 1 1 1v15l-6-4-6 4V5a1 1 0 0 1 1-1Z'></path></svg>";

  /* ---------------- Almacen ---------------- */

  function read() {
    try {
      var raw = JSON.parse(localStorage.getItem(KEY) || '[]');
      if (!Array.isArray(raw)) { return []; }
      return raw.filter(function (h) { return typeof h === 'string' && h.length; });
    } catch (e) {
      return [];
    }
  }

  function write(list) {
    try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {}
  }

  function toggle(handle) {
    var list = read();
    var i = list.indexOf(handle);
    if (i > -1) { list.splice(i, 1); } else { list.unshift(handle); }
    write(list);
    return i === -1;
  }

  /* ---------------- Pintado ---------------- */

  function paint() {
    var list = read();

    var buttons = document.querySelectorAll('[data-fav-handle]');
    for (var i = 0; i < buttons.length; i++) {
      var b = buttons[i];
      var on = list.indexOf(b.getAttribute('data-fav-handle')) > -1;
      b.classList.toggle('is-on', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
      b.setAttribute('aria-label', on ? 'Quitar de favoritos' : 'Guardar en favoritos');
    }

    var counters = document.querySelectorAll('[data-fav-count]');
    for (var j = 0; j < counters.length; j++) {
      counters[j].textContent = list.length;
      if (list.length > 0) {
        counters[j].removeAttribute('hidden');
      } else {
        counters[j].setAttribute('hidden', '');
      }

      /* El aria-label del enlace sustituye a su contenido, asi que
         el numero hay que meterlo tambien ahi o un lector de
         pantalla nunca lo lee. */
      var link = counters[j].parentNode;
      if (link && link.setAttribute) {
        link.setAttribute('aria-label', list.length > 0 ? 'Favoritos (' + list.length + ')' : 'Favoritos');
      }
    }
  }

  /* ---------------- Boton de la ficha de producto ----------------
     Se inyecta desde aqui para no tocar la seccion del producto.
     El handle se saca de la propia direccion de la pagina. */

  function handleFromPath() {
    var parts = location.pathname.split('/');
    var i = parts.indexOf('products');
    if (i === -1 || !parts[i + 1]) { return ''; }
    var raw = parts[i + 1].split('?')[0];
    /* Un % suelto en la direccion hace estallar decodeURIComponent
       y tumbaria el resto del script. */
    try { return decodeURIComponent(raw); } catch (e) { return raw; }
  }

  function injectProductButton() {
    var shell = document.querySelector('.vs-product-gallery-shell');
    if (!shell || shell.querySelector('[data-fav-handle]')) { return; }
    var handle = handleFromPath();
    if (!handle) { return; }
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'vs-fav vs-fav--product';
    btn.setAttribute('data-fav-handle', handle);
    btn.innerHTML = ICON;
    shell.appendChild(btn);
  }

  /* ---------------- Pagina de Favoritos ---------------- */

  function esc(text) {
    return String(text == null ? '' : text)
      .split('&').join('&amp;')
      .split('<').join('&lt;')
      .split('>').join('&gt;')
      .split('"').join('&quot;')
      .split("'").join('&#39;');
  }

  function money(cents, currency) {
    try {
      return new Intl.NumberFormat('es-ES', { style: 'currency', currency: currency || 'EUR' }).format(cents / 100);
    } catch (e) {
      return (cents / 100).toFixed(2) + ' EUR';
    }
  }

  function sized(url, width) {
    if (!url) { return ''; }
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + width;
  }

  function card(product, currency) {
    var image = sized(product.featured_image, 700);
    var price = money(product.price, currency);
    var compare = (product.compare_at_price && product.compare_at_price > product.price)
      ? money(product.compare_at_price, currency)
      : '';

    var html = "<article class='vs-product-card'>";
    html += "<a class='vs-product-media' href='" + esc(product.url) + "'>";
    if (image) {
      html += "<img src='" + esc(image) + "' alt='" + esc(product.title) + "' loading='lazy'>";
    }
    if (!product.available) { html += "<span class='vs-badge'>Agotado</span>"; }
    html += '</a>';
    html += "<button class='vs-fav is-on' type='button' data-fav-handle='" + esc(product.handle) + "' aria-pressed='true' aria-label='Quitar de favoritos'>" + ICON + '</button>';
    html += "<div class='vs-product-info'><div>";
    if (product.type) { html += '<p>' + esc(product.type) + '</p>'; }
    html += "<h3><a href='" + esc(product.url) + "'>" + esc(product.title) + '</a></h3></div>';
    html += "<div class='vs-price'><strong>" + price + '</strong>';
    if (compare) { html += '<s>' + compare + '</s>'; }
    html += '</div></div></article>';
    return html;
  }

  function renderPage() {
    var grid = document.querySelector('[data-favs-grid]');
    if (!grid) { return; }

    var empty = document.querySelector('[data-favs-empty]');
    var loading = document.querySelector('[data-favs-loading]');
    var error = document.querySelector('[data-favs-error]');
    var list = read();
    var currency = grid.getAttribute('data-currency') || 'EUR';

    function show(which) {
      grid.hidden = which !== 'grid';
      if (loading) { loading.hidden = which !== 'loading'; }
      if (empty) { empty.hidden = which !== 'empty'; }
      if (error) { error.hidden = which !== 'error'; }
    }

    if (!list.length) { grid.innerHTML = ''; show('empty'); return; }

    show('loading');

    var requests = list.map(function (handle) {
      return fetch(ROOT + 'products/' + encodeURIComponent(handle) + '.js', { headers: { Accept: 'application/json' } })
        .then(function (r) {
          if (r.ok) {
            return r.json().then(function (product) { return { answered: true, product: product }; });
          }
          /* 404 = el producto ya no existe. Cualquier otro codigo
             (429, 500, 503...) es un problema pasajero. */
          return { answered: r.status === 404, product: null };
        })
        .catch(function () { return { answered: false, product: null }; });
    });

    Promise.all(requests).then(function (results) {
      var html = '';
      var alive = [];
      var allAnswered = true;

      results.forEach(function (result, index) {
        if (!result.answered) { allAnswered = false; }
        if (result.product) {
          alive.push(list[index]);
          html += card(result.product, currency);
        }
      });

      /* Solo se recorta la lista si TODAS las respuestas fueron
         concluyentes, y releyendola por si se ha marcado algo
         nuevo mientras llegaban las peticiones. */
      if (allAnswered && alive.length !== list.length) {
        var current = read();
        write(current.filter(function (handle) {
          return list.indexOf(handle) === -1 || alive.indexOf(handle) > -1;
        }));
      }

      if (alive.length) {
        grid.innerHTML = html;
        show('grid');
        paint();
        return;
      }

      grid.innerHTML = '';
      show(allAnswered ? 'empty' : 'error');
      paint();
    });
  }

  /* ---------------- Eventos ---------------- */

  document.addEventListener('click', function (event) {
    if (!event.target || !event.target.closest) { return; }
    var btn = event.target.closest('[data-fav-handle]');
    if (!btn) { return; }

    /* Se captura antes que el enlace de la tarjeta para que marcar
       un favorito no abra la ficha del producto. */
    event.preventDefault();
    event.stopPropagation();

    var handle = btn.getAttribute('data-fav-handle');
    if (!handle) { return; }

    var added = toggle(handle);
    paint();

    btn.classList.remove('is-pop');
    void btn.offsetWidth;
    btn.classList.add('is-pop');

    /* En la propia pagina de Favoritos, al quitar uno desaparece. */
    if (!added && document.querySelector('[data-favs-grid]')) { renderPage(); }
  }, true);

  /* Si lo cambia en otra pestana, se refresca aqui. */
  window.addEventListener('storage', function (event) {
    if (event.key === KEY) { paint(); renderPage(); }
  });

  function init() {
    /* Cada paso en su propio try: que un fallo en uno no deje los
       otros dos sin ejecutar. */
    try { injectProductButton(); } catch (e) {}
    try { paint(); } catch (e) {}
    try { renderPage(); } catch (e) {}
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);

  window.VeraFavs = { refresh: paint, list: read };
})();
